import React, { useState } from 'react'
import  Button  from '@material-ui/core/Button';
import { Input } from '@material-ui/core';
import { db, storage } from './firebase.js';
import firebase from "firebase"
import './ImageUpload.css';
import { makeStyles } from '@material-ui/core/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';


const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  }));


function ImageUpload({username}) {


    
    const classes = useStyles();


    const [image, setImage] = useState('null')
    const [progress, setProgress] = useState('0')
    const [caption, setCaption] = useState('')
    const [iconColor, setIconColor] = useState('grey')



const handleChange = (e) => {

    if(e.target.files[0]);
        setImage(e.target.files[0])

        if (image !== null) {

            setIconColor("secondary")

        } else {
            setIconColor("grey")
        }
    
        console.log(iconColor)

    }

    

const handleUpload = (e) => {

        const uploadTask = storage.ref(`images/${image.name}`).put(image);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                //progress function
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                )
                setProgress(progress);
            },
            (error) => {
                //error function
                console.log(error);
            },
            () => {
                //complete function
                storage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then (url => {
                    //post image inside of the database
                    db.collection("posts").add({
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption: caption,
                        imageURL: url,
                        username: username
                    });

                    setProgress(0);
                    setCaption("");
                    setImage(null);
                })
            }
        )
    }



    return (
        <div className="imageupload">
            
            <progress className='imageupload__Progress' value ={progress} max="100"/>

            <div className="imageupload__Form">

            <Input type="text" placeholder="Enter a caption" onChange={event => setCaption(event.target.value)} value={caption}/>

                <div className={classes.root}>

                {/* Upload Photo*/}

                <Input className={classes.input}  id="icon-button-file"  type="file" onChange={handleChange} />

                <label htmlFor="icon-button-file"> <IconButton  color={iconColor} aria-label="upload picture" component="span"><PhotoCamera /></IconButton>
                    </label>
                
                {/*Submit Post*/}

                <Button onClick={handleUpload}>Upload</Button>

                </div>
            </div>
        </div>
    )
}

export default ImageUpload;
